import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import BlogIndexPage from './pages/BlogIndexPage';
import BlogPostPage from './pages/BlogPostPage';
import BookingSuccessPage from './pages/BookingSuccessPage';
import BookingModal from './components/BookingModal';
import LoginModal from './components/LoginModal';
import { Toaster } from './components/ui/toaster';

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingLessonId, setBookingLessonId] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);

  const openBooking = (lessonId = null) => {
    // Accept either a lesson id (number) or no argument (from generic CTAs)
    setBookingLessonId(typeof lessonId === 'number' ? lessonId : null);
    setBookingOpen(true);
  };
  const openLogin = () => setLoginOpen(true);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-sans antialiased selection:bg-amber-400/30 selection:text-amber-100">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<HomePage onOpenBooking={openBooking} onOpenLogin={openLogin} />}
          />
          <Route
            path="/blog"
            element={<BlogIndexPage onOpenBooking={openBooking} onOpenLogin={openLogin} />}
          />
          <Route
            path="/blog/:slug"
            element={<BlogPostPage onOpenBooking={openBooking} onOpenLogin={openLogin} />}
          />
          <Route
            path="/booking/success"
            element={
              <BookingSuccessPage onOpenBooking={openBooking} onOpenLogin={openLogin} />
            }
          />
        </Routes>
      </BrowserRouter>

      <BookingModal
        open={bookingOpen}
        onClose={() => setBookingOpen(false)}
        initialLessonId={bookingLessonId}
      />
      <LoginModal open={loginOpen} onClose={() => setLoginOpen(false)} />
      <Toaster />
    </div>
  );
}

export default App;
